import { useState, useEffect, useRef } from "react"; // ADD useRef
import { motion, AnimatePresence } from "framer-motion";
import ItemCard from "./ItemCard";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { colors } from "../colors";
import Bowls from "../images/CLIPARTS/Bowls.png";
import Desserts from "../images/CLIPARTS/Desserts.png";
import Crisps from "../images/CLIPARTS/Crisps.png";
import Subs from "../images/CLIPARTS/Sandwiches.png";
import Salads from "../images/CLIPARTS/Salads.png";
import Wraps from "../images/CLIPARTS/Wraps.png";
import Breakfast from "../images/CLIPARTS/Breakfast.png";
import Sides from "../images/CLIPARTS/Sides.png";
import HotDrinks from "../images/CLIPARTS/HotDrinks.png";
import SoftDrinks from "../images/CLIPARTS/SoftDrinks.png";
import JackedPotato from "../images/CLIPARTS/JackedPotato.png";
import IceCream from "../images/CLIPARTS/IceCream.png";
import CartModal from "./CartModal";
import Cart from "./Cart";
import AuthModal from "./AuthModal";
import { addToCart } from "../store/cartSlice";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  getCart,
  loginUser,
  signUpUser,
  verifyOtp,
} from "../services/api";
import { setUser } from "../store/userSlice";
import { closeAuthModal } from "../store/modalSlice"; // Import the action
import { Search, X } from "lucide-react";

const stripePromise = loadStripe(
  "pk_live_51SJyRNGlKX6C1N1BsaTyxjT7WDnOJCDoanb4z6rkfGVjXSF2WvbS8Aia16Pu2tyw7enE5XWnXNGnapBasSvc2Jyh00OKVpoBT5"
);

function Menu() {
  const menuItems = useSelector((state) => state.menuItems.items);
  const menuItemsLoading = useSelector((state) => state.menuItems.loading);
  const menuItemsError = useSelector((state) => state.menuItems.error);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("Breakfast");
  const [selectedSubItem, setSelectedSubItem] = useState("Pizza");
  const [direction, setDirection] = useState(0);
  const [totalShown, setTotalShown] = useState(3);
  const [cartModalItem, setCartModalItem] = useState(null);
  const user = useSelector((state) => state.user.user);
  const showAuthModal = useSelector((state) => state.modal.showAuthModal);

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const contentRef = useRef(null); // ADD THIS LINE
  const offers = useSelector((state) => state.offers?.list || []);
  const dispatch = useDispatch();

  const getFilteredItems = () => {
    if (!searchQuery.trim()) return [];

    return menuItems.filter(item =>
      item.availability === true &&
      item.website === true &&
      (item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.Type?.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  };

  const handleLogin = async (data) => {
    try {
      const response = await loginUser(data);
      console.log("Login Successful:", response.data);
      dispatch(setUser(response.data));

      // Only fetch cart if session was stored
      if (response.data.sessionStored !== false) {
        const cartResponse = await getCart(response.data.user.id);
        console.log("CART AFTER LOGIN DATA:", cartResponse);

        if (cartResponse.data.success && cartResponse.data.cart.length > 0) {
          const formattedCart = cartResponse.data.cart.map((item) => ({
            id: item.item_id,
            title: item.item_name,
            image: item.image_url,
            description: item.additional_description,
            itemQuantity: item.quantity,
            totalPrice: item.total_price,
          }));

          formattedCart.forEach((cartItem) => dispatch(addToCart(cartItem)));
        }
      } else {
        console.log("Session not stored - cart will not persist");
      }

      dispatch(closeAuthModal());
    } catch (error) {
      console.error("Login Error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Login failed.");
    }
  };

  const handleSignUp = async (data) => {
    try {
      const response = await signUpUser(data);
      if (response.data.success) {
        const otp = prompt("Enter the OTP sent to your email:");
        if (otp) {
          const verifyResponse = await verifyOtp(data, otp);
          if (verifyResponse.data.success) {
            dispatch(setUser(verifyResponse.data));

            if (verifyResponse.data.sessionStored === false) {
              toast.success("Account created! Note: Your session won't be saved.", {
              });
            } else {
              toast.success("Account created successfully!", {
              });
            }

            setTimeout(() => {
              dispatch(closeAuthModal());
            }, 2000);
          } else {
            toast.error("OTP verification failed.");
          }
        }
      }
    } catch (error) {
      console.error("Signup Error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Signup failed.");
    }
  };

  const handleGuest = () => {
    console.log("Continue as Guest");
    dispatch(closeAuthModal()); // Close the modal when continuing as guest
  };

  useEffect(() => {
    const updateTotalShown = () => {
      if (window.innerWidth >= 1200) {
        setTotalShown(5); // Desktop
      } else if (window.innerWidth >= 768) {
        setTotalShown(7); // Tablet
      } else {
        setTotalShown(4); // Mobile
      }
    };

    updateTotalShown(); // Set initial state
    window.addEventListener("resize", updateTotalShown);

    return () => {
      window.removeEventListener("resize", updateTotalShown);
    };
  }, []);

  const menuCategories = [
    "Breakfast",
    "Subs",
    "Wraps",

    "JackedPotato",
    "Salads",
    "Bowls",
    "Sides",
    "SoftDrinks",
    "HotDrinks",
    "IceCream",
    "Desserts",
    "Crisps",
  ];


  const images = {
    Breakfast,
    Subs,
    Wraps,
    Salads,
    Bowls,
    Sides,
    SoftDrinks,
    HotDrinks,
    IceCream,
    Desserts,
    Crisps,
    JackedPotato,
  };
  useEffect(() => {
    console.log("Menu items updated:", menuItems);
  }, [menuItems]);

  const handleClick = (item) => {
    console.log(offers);
    console.log(menuItems);
    const currentIndex = menuCategories.indexOf(selectedItem);
    const newIndex = menuCategories.indexOf(item);

    setDirection(newIndex > currentIndex ? 1 : -1);
    setSelectedItem(item);
    
  };

  const MenuTextStyle = {
    fontFamily: "Bambino",
    fontWeight: 550,
    marginTop: "5px",
    transition: "all 0.3s ease",
  };

  const MenuTextStyleHover = {
    ...MenuTextStyle,
    backgroundColor: colors.primaryRed,
    borderRadius: "15px",
    color: "white",
  };

  const handleOpenCartModal = (item) => {
    setCartModalItem(item);
  };

  const handleCloseCartModal = () => {
    setCartModalItem(null);
  };
  if (menuItemsLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading menu...
      </div>
    );
  }

  if (menuItemsError) {
    return (
      <div className="flex justify-center items-center h-screen text-red-500">
        Error loading menu: {menuItemsError}
      </div>
    );
  }

  const renderOffers = () => {
    return (
      <div className="w-full mt-3 md:mt-6 pl-3 pr-3 lg:pl-0 lg:pr-8 pb-3 lg:pb-0">
        <div className="overflow-x-auto whitespace-nowrap custom-scrollbar3 pb-1">
          {offers &&
            offers
              .filter((offer) => offer.value === true)
              .map((offer, index) => (
                <div
                  key={index}
                  className="inline-block p-2 text-white text-center text-xxs lg:text-xs mr-4"
                  style={{
                    borderRadius: "12px",
                    fontFamily: "Bambino",
                    fontWeight: 350,
                    backgroundColor: colors.primaryRed,
                  }}
                >
                  {offer.offer_text}
                </div>
              ))}
        </div>
      </div>
    );
  };

  const renderCategoryImages = () => {
    return (
      <div className="w-full px-3 lg:px-10">
        <div className="overflow-x-auto whitespace-nowrap custom-scrollbar2 pb-0 lg:pb-1">
          {menuCategories.map((category) => (
            <div
              key={category}
              className="inline-block p-2 text-center text-xxs lg:text-xs mr-3 lg:mr-10"
              onClick={() => handleClick(category)}
              style={{ cursor: "pointer" }}
            >
              <div className="flex flex-col items-center justify-center">
                <img
                  className="h-16 lg:h-28 w-auto"
                  src={images[category]}
                  alt={category}
                />
                <div
                  className="text-xxs lg:text-base text-center px-2 w-full flex justify-center items-center"
                  style={
                    selectedItem === category
                      ? MenuTextStyleHover
                      : MenuTextStyle
                  }
                >
                  {category.toUpperCase()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="grid grid-cols-4">
        {/* Render offers below categories */}
        <div
          className="fixed top-0 left-0 lg:left-44  w-[100%] lg:w-[64%] bg-white lg:bg-transparent"
          style={{
            zIndex: 53,
          }}
        >
          {renderOffers()}
        </div>
        <div
          className="fixed top-[3.25rem] lg:top-16 left-0  w-[100%] lg:w-[75%] bg-white"
          style={{ zIndex: 47 }}
        >
          {renderCategoryImages()}
        </div>
        <div className="fixed top-[10.2rem] lg:top-[15rem] ml-[90%] lg:ml-[64%]  w-[10%] lg:w-[10%] bg-none flex justify-end pr-4 lg:pr-10 "
          style={{ zIndex: 48 }}>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              if (isSearchOpen) setSearchQuery(""); // clear input when closing
              setIsSearchOpen(!isSearchOpen);
            }}
            className="p-1.5 lg:p-2" // smaller padding on mobile
            style={{
              backgroundColor: isSearchOpen ? colors.primaryRed : colors.primaryGreen,
              borderRadius: "50%",
              color: "white",
            }}
          >
            {isSearchOpen ? <X size={16} className="lg:w-5 lg:h-5" /> : <Search size={16} className="lg:w-5 lg:h-5" />}
          </motion.button>


        </div>


        <AnimatePresence>
          {isSearchOpen && (
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              className="fixed top-[9.8rem] lg:top-[14.4rem] left-0  w-[87%] lg:w-[70%] bg-none flex justify-end rounded-xl"
              style={{ zIndex: 49 }}
            >
              <div className="p-1 lg:p-2">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="text-sm lg:text-base w-full p-1 lg:px-2 lg:py-2 border-2 rounded-lg focus:outline-none focus:border-green-500"
                  style={{
                    fontFamily: "Bambino",
                    borderColor: colors.primaryGreen,
                  }}
                  autoFocus
                />
              </div>
            </motion.div>

          )}
        </AnimatePresence>


        <div className="mt-56 col-span-4 lg:col-span-3 ">
          <AnimatePresence custom={direction}>
            <div
              className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 lg:gap-8 mx-4 lg:mx-20 mt-0 lg:mt-16"
              style={{ position: "relative", zIndex: "10" }}
            >
              {searchQuery.trim() ? (
                // Show search results
                getFilteredItems().length > 0 ? (
                  getFilteredItems().map((item) => (
                    <div key={`${item.id}-${item.availability}`} className="col-span-1">
                      <ItemCard
                        menuItems={item}
                        onAddToCart={() => handleOpenCartModal(item)}
                      />
                    </div>
                  ))
                ) : (
                  <div className="col-span-full text-center py-10" style={{ fontFamily: "Bambino" }}>
                    No items found for "{searchQuery}"
                  </div>
                )
              ) : (
                // Show category items as before
                menuItems.map(
                  (item) =>
                    item.Type === selectedItem &&
                    (item.subType === selectedSubItem ||
                      item.subType === null) &&
                    item.availability === true &&
                    item.website === true && (
                      <div key={`${item.id}-${item.availability}`} className="col-span-1">
                        <ItemCard
                          menuItems={item}
                          onAddToCart={() => handleOpenCartModal(item)}
                        />
                      </div>
                    )
                )
              )}
            </div>
          </AnimatePresence>

          {cartModalItem && (
            <CartModal
              isOpen={!!cartModalItem}
              onClose={handleCloseCartModal}
              item={cartModalItem}
            />
          )}
        </div>
        {/* Cart Component */}
        <div className="hidden lg:block col-span-1 ">
          <Elements stripe={stripePromise}>
            <Cart
              isOpen={true}
              onClose={() => setIsCartOpen(false)}
            />
          </Elements>
        </div>
        <AnimatePresence>
          {showAuthModal && !user && (
            <AuthModal
              onClose={() => dispatch(closeAuthModal())} // Dispatch the action to close the modal
              onLogin={handleLogin}
              onSignUp={handleSignUp}
              onGuest={handleGuest}
            />
          )}
        </AnimatePresence>

      </div>
    </>
  );
}

export default Menu;
